import styled from 'styled-components';

export const LayoutRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  min-height: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  width: 100%;
  max-width: var(--content-max-width);
  min-width: 0;
  min-height: 0;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const BannersSection = styled.section`
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
`;

export const BannersInner = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
`;
